import React, { useEffect, useState, useCallback } from "react";
import "./HomePage.css";
import { Link, useNavigate } from "react-router-dom";
import beautyProductImage from "../first-product.png";
import recommendedImage from "../images/recommended.png";
import searchIcon from "../images/search.png";
import { getProfileInfo } from "../api/auth";
import Spinner from "../components/Spinner";
import api, { getCache, setCache } from "../components/api";
import ProductItem from "../components/ProductItem";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import BannerIcon1 from "../images/curu-chats-banner-1.svg";
import { trackSkinQuiz } from "../components/xpUtils";
import { notifySessionExpired } from "../utils/sessionBus";
import WelcomePopup from "../homepage/WelcomePopup";

const HomePage = () => {
  const navigate = useNavigate();
  const [showRecommededProducts, setShowRecommededProducts] = useState(false);
  const [rec_for_you, setRec_for_you] = useState([]);
  const [isRecProductsEmpty, setIsRecProductsEmpty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [recItems, setRecItems] = useState([]);
  const [apiUrl, setApiUrl] = useState(null);
  const [subCategories, setSubCategories] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [chunkedCategories, setChunkedCategories] = useState([]);
  const [banners, setBanners] = useState(getCache("banners"));

  const [showPopup, setShowPopup] = useState(false);

  const [setPopupMessage] = useState("");

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const fetchData = async () => {
    let subCategoryArray = getCache("subcategories-category-1");
    if (!subCategoryArray) {
      const subCategoryResponse = await api.get("/sub-categories", {
        params: {
          category: 1,
        },
      });

      subCategoryArray = subCategoryResponse.data;
      setCache("subcategories-category-1", subCategoryArray);
    }
    setSubCategories(subCategoryArray);

    let bannerArray = getCache("banners");
    if (!bannerArray) {
      const bannerResponse = await api.get("/banners");
      bannerArray = bannerResponse.data;

      setCache("banners", bannerArray);
    }
    console.log(bannerArray);
    setBanners(bannerArray);
  };

  const chunkCategories = useCallback(() => {
    if (!subCategories || subCategories.length === 0) {
      return;
    }

    // Use window.innerWidth directly for media breakpoints
    const width = window.innerWidth;
    let chunkSize = 6; // default chunk size for large screens

    if (width < 768) {
      chunkSize = 2; // mobile screens
    } else if (width < 1230) {
      chunkSize = 3; // small tablet screens
    } else if (width < 1536) {
      chunkSize = 5; // bigger tablet screens
    }

    const chunks = [];
    for (let i = 0; i < subCategories.length; i += chunkSize) {
      chunks.push(subCategories.slice(i, i + chunkSize));
    }

    setChunkedCategories(chunks); // set chunked categories based on screen size
  }, [subCategories]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    chunkCategories();

    const handleResize = () => chunkCategories(); // add event listener to adjust layout on window resize
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [chunkCategories, subCategories]);

  useEffect(() => {
    getSkinQuizStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsRecProductsEmpty(
      Object.keys(rec_for_you).length === 0 ||
        Object.keys(rec_for_you).every((key) => rec_for_you[key] === null)
    );
  }, [rec_for_you]);

  //check and retrieve the skin quiz status for the user
  const getSkinQuizStatus = async () => {
    try {
      setLoading(true); // Set loading to true before fetching data
     // Local token guard: If there is no token, a pop-up window will appear and an error will be thrown (going to catch).
     const token = localStorage.getItem("token");
      if (!token) {
        notifySessionExpired();
        throw new Error("No token found. Please log in again.");
      }

      const response = await getProfileInfo(); // Fetch user profile information from the server

      // Parse the JSON only once to avoid repeatedly reading the body
      const profileDetails = await response.json();
      if (!response.ok) {
        throw new Error(
          `Failed to get profile info: ${profileDetails?.message || response.statusText}`
        );
      } 
      

      const {
        isFirstLogin,
        skin_type,
        skin_concerns,
        skin_sensitive_type,
        skin_undertone,
        skin_tone,
        id,
      } = profileDetails;

      // Check if this is the user's first login
      if (isFirstLogin) {
        setPopupMessage("Welcome! It's your first time here."); // Set a welcome message for new users
        setShowPopup(true); // Show a popup for first-time users
        localStorage.setItem("isNewUser", "true"); // Store new user status in localStorage
        sessionStorage.setItem("userStatus", "new"); // Store user status as 'new' in sessionStorage
      } else {
        localStorage.setItem("isNewUser", "false"); // Mark user as returning in localStorage
        sessionStorage.setItem("userStatus", "old"); // Mark user status as 'old' in sessionStorage
      }

      // Check if user has any skin-related information filled out in profile
      const hasSkinInfo =
        skin_type ||
        (skin_concerns && skin_concerns.length > 0) ||
        skin_sensitive_type ||
        skin_undertone ||
        skin_tone;

      // Check if user has completed the FULL skin quiz (all fields)
      const isFullSkinQuizComplete =
        skin_type &&
        skin_concerns &&
        skin_concerns.length > 0 &&
        skin_sensitive_type &&
        skin_undertone &&
        skin_tone;

      // Only award XP if user just completed the quiz
      // Check if this is a fresh completion (coming from skin quiz pages)
      const justCompletedQuiz = sessionStorage.getItem("justCompletedSkinQuiz");

      if (isFullSkinQuizComplete && justCompletedQuiz === "true") {
        const hasShownQuizXP = localStorage.getItem(`skinQuizXPShown_${id}`);

        if (!hasShownQuizXP) {
          console.log("✅ User just completed skin quiz - awarding XP!");
          trackSkinQuiz();
          localStorage.setItem(`skinQuizXPShown_${id}`, "true");

          // Dispatch custom event to trigger XP popup immediately
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("check-xp-earned"));
          }, 500);
        }

        // Clear the flag so it doesn't trigger again
        sessionStorage.removeItem("justCompletedSkinQuiz");
      }

      // If user has skin info, prepare recommendation criteria
      if (hasSkinInfo) {
        const For_you = {
          for_you: true, // Enable recommendations
          skin_sensitive: skin_sensitive_type ? skin_sensitive_type.id : null, // Add sensitive skin info if available
        };
        setRec_for_you(For_you); // Set recommendation parameters
        await getRecommendedProducts(true, For_you); // Fetch recommended products based on criteria
      }

      setShowRecommededProducts(hasSkinInfo); // Show recommended products section if skin info is available
    } catch (error) {
      console.error(error.message);
      throw error;
    } finally {
      setLoading(false); // Set loading to false once data fetching is complete
    }
  };

  // fetch recommended products based on user criteria
  const getRecommendedProducts = async (initPage = false, rec_for_you = {}) => {
    setLoading(true); // Indicate loading during product fetch

    try {
      const response =
        apiUrl && !initPage
          ? await api.get(apiUrl)
          : await api.get("/products", {
              params: {
                limit: 4,
                offset: 0,
                ...rec_for_you,
              },
            });

      const data = await response.data;
      setApiUrl(data.next ? decodeURIComponent(data.next) : null); // Set the URL for the next page of products if available

      // If there are no results, indicate that the recommended product list is empty
      if (data.results.length === 0) {
        setIsRecProductsEmpty(true);
      }

      // Update the recommended items list, adding new products to existing ones if not an initial fetch
      // Deduplicate products by name to prevent duplicates
      setRecItems((prevItems) => {
        if (initPage) {
          // Deduplicate even on initial load in case API returns duplicates
          const uniqueResults = [];
          const seenNames = new Set();
          const duplicateNames = [];
          
          for (const item of data.results) {
            // Try multiple possible name fields
            const productName = item.name || item.product_name || item.title || item.product_title || '';
            const normalizedName = productName.toLowerCase().trim();
            
            if (!seenNames.has(normalizedName)) {
              seenNames.add(normalizedName);
              uniqueResults.push(item);
            } else {
              duplicateNames.push(productName);
            }
          }
          
          console.log('HomePage initial load deduplication by name:', {
            original: data.results.length,
            unique: uniqueResults.length,
            removed: data.results.length - uniqueResults.length,
            duplicateNames: duplicateNames.slice(0, 10) // Show first 10 duplicates
          });
          return uniqueResults;
        } else {
          // Create a map of existing items by name for efficient lookup
          const existingItemsMap = new Map(prevItems.map(item => {
            const name = item.name || item.product_name || item.title || item.product_title || '';
            return [name.toLowerCase().trim(), item];
          }));
          
          const newItems = data.results.filter(item => {
            const productName = item.name || item.product_name || item.title || item.product_title || '';
            const normalizedName = productName.toLowerCase().trim();
            return !existingItemsMap.has(normalizedName);
          });
          
          console.log('HomePage load more deduplication by name:', {
            existing: prevItems.length,
            newFromAPI: data.results.length,
            newUnique: newItems.length,
            removed: data.results.length - newItems.length
          });
          return [...prevItems, ...newItems];
        }
      });
    } catch (error) {
      console.error("Failed to fetch recommended products:", error);
    } finally {
      setLoading(false); // End loading state after product fetch completes
    }
  };

  // Function to navigate to the recommended products page, passing recommendation criteria as state
  const navigateToRecommendedProducts = async () => {
    navigate("/recommended-products", { state: { rec_for_you } });
  };

  const navigateToCuruChats = async () => {
    navigate("/curu-chats");
  };

  // Final deduplication before rendering to ensure no duplicates
  const uniqueRecItems = React.useMemo(() => {
    const seenNames = new Set();
    const result = [];
    
    for (const item of recItems) {
      const productName = item.name || item.product_name || item.title || item.product_title || '';
      const normalizedName = productName.toLowerCase().trim();
      
      if (!seenNames.has(normalizedName)) {
        seenNames.add(normalizedName);
        result.push(item);
      }
    }
    
    console.log('HomePage final render deduplication:', {
      original: recItems.length,
      unique: result.length,
      removed: recItems.length - result.length
    });
    
    return result;
  }, [recItems]);

  // manage popup visibility based on user login status
  useEffect(() => {
    const isNewUser = localStorage.getItem("isNewUser"); // Retrieve new user status from localStorage
    const userStatus = sessionStorage.getItem("userStatus"); // Retrieve user status from sessionStorage

    // If user is returning, do not show the popup
    if (userStatus === "old") {
      setShowPopup(false); // Do not show the popup for old users
    } else if (isNewUser === "true" || userStatus === "new") {
      setShowPopup(true); // Show the popup for new users
      localStorage.setItem("isNewUser", "false"); // Update new user status in localStorage
    }
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    hideHomePagePopup();
  };

  const hideHomePagePopup = () => {
    const popupElement = document.getElementById("home-popup");
    if (popupElement) {
      popupElement.style.display = "none"; // Hide popup
    }
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    autoplay: true, // Enable auto-scroll
    autoplaySpeed: 3000, // Scroll every 3 seconds
    rows: 1, // Ensure single row
    slidesPerRow: 1, // Ensure 1 slide per row

    responsive: [
      {
        breakpoint: 768, // Medium screens like tablets
        settings: {
          slidesToShow: 2, // Show 2 slides per row
          slidesToScroll: 2, // Scroll 2 slides at a time
        },
      },
      {
        breakpoint: 576, // Small screens like mobile
        settings: {
          slidesToShow: 1, // Show 1 slide per row
          slidesToScroll: 1, // Scroll 1 slide at a time
        },
      },
    ],
  };

  return (
    <div className="content w-100">
      <div className="homepage-container">
        {showPopup && (
          <div id="home-popup">
            <WelcomePopup onClose={handleClosePopup} />
          </div>
        )}
        <div className="content">
          <div className="image-container">
            <img
              src={beautyProductImage}
              alt="Beauty Product"
              className="beauty-product"
            />
            <div className="overlay-text">Discover your beauty!</div>
          </div>
          <div>
            <div className="home-headings mt-4"> Categories </div>
            <div className="container category-container">
              <Carousel
                activeIndex={activeIndex}
                onSelect={handleSelect}
                indicators={false}
                interval={null}
                className="category-carousel"
                nextIcon={
                  activeIndex < chunkedCategories.length - 1 ? (
                    <span
                      aria-hidden="true"
                      className="carousel-control-next-icon custom-next"
                    />
                  ) : null
                }
                prevIcon={
                  activeIndex > 0 ? (
                    <span
                      aria-hidden="true"
                      className="carousel-control-prev-icon custom-prev"
                    />
                  ) : null
                }
              >
                {chunkedCategories.map((categoryGroup, index) => (
                  <Carousel.Item key={index}>
                    <div className="d-flex justify-content-center align-items-center">
                      {categoryGroup.map((category) => (
                        <div key={category.id} className="category-box me-3">
                          <Link to={`/products/category/1/${category.id}`}>
                            <img
                              src={`${process.env.PUBLIC_URL}/images/icons/${category.name}.svg`}
                              alt={category.name}
                              className="category-image"
                            />
                            <div className="category-name">{category.name}</div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
        {/* Begin Recommended for you */}
        <div>
          <div className="home-headings mt-4"> Recommended for you </div>
          {loading ? (
            <Spinner />
          ) : showRecommededProducts ? (
            isRecProductsEmpty ? (
              <div className="text-center py-4">
                <div className="no-products-image-container">
                  <img
                    src={searchIcon}
                    alt="No products found"
                    className="no-products-image"
                  />
                </div>

                <h4 className="mb-3">No Products Found</h4>
                <p className="text-muted">
                  Sorry! We couldn't find anything that matches your filters.
                </p>
                <button
                  className="change-filters"
                  onClick={() => {
                    navigateToRecommendedProducts();
                  }}
                >
                  Change filters
                </button>
              </div>
            ) : (
              <div className="grid">
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 g-4 mt-3">
                  {uniqueRecItems.map((item, index) => {
                    const productName = item.name || item.product_name || item.title || item.product_title || '';
                    const normalizedName = productName.toLowerCase().trim();
                    return (
                      <div key={`${normalizedName}-${index}`} className="col">
                        <ProductItem item={item} />
                      </div>
                    );
                  })}
                </div>
                {apiUrl && (
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary text-white m-auto px-4"
                      onClick={() => {
                        navigateToRecommendedProducts();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      View All
                    </button>
                  </div>
                )}
              </div>
            )
          ) : (
            <div className="image-container">
              <img
                src={recommendedImage}
                alt="Two girls"
                className="recommended-image"
              />
              <div className="overlay-box">
                <h1>Take Our Quiz</h1>
                <p>
                  Tell us more to help us find the perfect products for you. It
                  only takes a minute!
                </p>
                <Link to="/Skin-Type">
                  <button className="recommended-button">
                    Find products for me
                  </button>
                </Link>
              </div>
            </div>
          )}
          {/* End Recommended for you */}
        </div>

        <div>
          <div className="home-headings">Curu chats</div>
          <div className="curu-chats-container">
            <img
              src={BannerIcon1}
              alt="Curu Chats Banner"
              className="curu-chats-image"
            />
            <div className="curu-chats-overlay">
              <div className="curu-chats-text-container">
                Join the conversation #CuruChats
              </div>
              <div className="curu-chats-button">
                <button
                  className="btn btn-primary text-white px-4"
                  onClick={() => {
                    navigateToCuruChats();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Let's talk beauty
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="home-headings">Featured</div>
          <div className="featured-container">
            {banners && banners.length > 0 && (
              <Slider {...sliderSettings}>
                {banners.map((banner, index) => (
                  <div key={index}>
                    <img src={banner.image} alt="" className="img-fluid" />
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
